module.exports = __webpack_public_path__ + "skyline2.37ecd12a07e6d4d7f6d5.jpg";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/skyline2.jpg
// module id = ../../../../../client/assets/img/skyline2.jpg
// module chunks = styles